import { DeleteOrphanedTranslationsDto } from '@routellers/types/dist/translation/delete-orphaned-translations.dto';

import { ApiMethodDeclaration } from '..';

type ParamsData = { data: DeleteOrphanedTranslationsDto };

type ResponseData = { deleted: number; notFound: string[]; skipped: string[] };

export const deleteOrphanedTranslations: ApiMethodDeclaration<ParamsData, ResponseData> = ({
    data,
}) => ({
    url: '/translations/delete-orphaned',
    method: 'POST',
    data,
});
